import { WarningAlert } from "@/components/ui/Alert.tsx";
import { useFormContext } from "react-hook-form";
import { NewPasswordFormInput } from "@/types";
import usePasswordValidation from "@/utils/hooks/usePasswordValidation.ts";

export default function PasswordStrength() {
  const { watch } = useFormContext<NewPasswordFormInput>();
  const { hasMinLength, hasNumber, hasSymbol, hasUpperCase, hasLowerCase } =
    usePasswordValidation(watch("password"));

  return (
    <div className="flex w-full flex-col gap-1 justify-center items-start">
      {!hasUpperCase && (
        <WarningAlert message="It must contain an uppercase letter" />
      )}

      {!hasMinLength && (
        <WarningAlert message="It must have a minimum of 8 characters" />
      )}

      {!hasLowerCase && (
        <WarningAlert message="It must contain a lowercase letter" />
      )}

      {(!hasSymbol || !hasNumber) && (
        <WarningAlert message="It must contain a number and a symbol" />
      )}

      {(!hasSymbol || !hasNumber) && (
        <WarningAlert
          message={
            "Acceptable symbols: ! @ # $ % ^ & * ( ) _ + = - [ ] { } ; ' : \"  | , . < > / ?"
          }
        />
      )}
    </div>
  );
}
